import React from "react";
import PropTypes from "prop-types";
import FuxCursorPaginator from "../../../components/BaseComponents/FuxCursorPaginator/FuxCursorPaginator";
import {UsersModuleEventsAPI} from "../../../api/UsersModuleEvents/UsersModuleEventsAPI";
import {UserEventReservationItem} from "./UserEventReservationItem";

export class UserEventReservationsList extends React.Component {
    constructor(props) {
        super(props);
        this.classItemsContainer = "list-group";
    }

    handlePageRequest = cursor => UsersModuleEventsAPI.User.reservationPagination(this.props.eventId, cursor)

    handleItemRender = reservation => (
        <UserEventReservationItem
            reservation={reservation}
            onClick={this.props.onReservationClick}
        />
    )

    handleEmptyPage = _ => (
        <div className={"text-center text-muted py-4 card card-body shadow-sm border-0"}>
            Non ci sono ancora adesioni.
        </div>
    )

    render() {
        return (
            <div>
                <h6 className={"font-weight-bold mb-3"}>Adesioni ricevute</h6>
                <FuxCursorPaginator
                    classItemsContainer={this.classItemsContainer}
                    onItemRender={this.handleItemRender}
                    onPageRequest={this.handlePageRequest}
                    onEmptyPage={this.handleEmptyPage}
                />
            </div>
        );
    }
}

UserEventReservationsList.propTypes = {
    eventId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onReservationClick: PropTypes.func,
};
